module.exports = __webpack_public_path__ + "img/hlh.e106d181.jpg";